import styled from 'styled-components'
import tw from 'twin.macro'

function TabPanel(props) {
  const { children, value, index, curValue, ...other } = props

  return (
    <div
      role="tabpanel"
      hidden={value !== curValue}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      <div>{children}</div>
    </div>
  )
}

const styledTabPanel = styled(TabPanel)`
  margin: 0 auto;
  margin-bottom: 50px;
  max-width: 768px;
  ${tw`border-t border-gray-100`}
`

export default styledTabPanel
